import React from "react";
import TextField from "./TextField";
import { normalizeAddress } from "../utils/formattingUtils";
import { SxProps, Theme } from "@mui/material";

interface Props {
    value: string;
    onChange: (value: string) => void;
    onBlur?: () => void;
    error?: boolean;
    helperText?: string;
    placeholder?: string;
    fullWidth?: boolean;
    ref?: React.RefObject<HTMLInputElement>;
    nextRef?: React.RefObject<HTMLInputElement>;
    sx?: SxProps<Theme>;
}

const AddressField = ({
    value,
    onChange,
    onBlur,
    error,
    helperText,
    placeholder,
    fullWidth = true,
    ref,
    nextRef,
    sx,
}: Props) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.currentTarget.value;
        const normalized = normalizeAddress(raw);
        onChange(normalized);
    };

    return (
        <TextField
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onBlur={onBlur}
            error={error}
            helperText={helperText}
            fullWidth={fullWidth}
            nextRef={nextRef}
            ref={ref}
            suffix={".jemloc.com"}
            sx={{ ...sx }}
        />
    );
};

export default AddressField;
